import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { groupBy } from 'lodash';
import { isVoid } from '@/utils/common';
import ConfigServerGroup from './ConfigServerGroup';
import ConfigServerHost from './ConfigServerHost';

function Servers({ steps, flowGroup }) {
  // 主机组节点，其他无主机组节点
  const [groups, otherSteps] = useMemo(() => {
    // 含有组的步骤
    const hasGroupSteps = steps.filter((item) => !isVoid(item.groupId));
    // 无组步骤
    const noGroupSteps = steps.filter((item) => isVoid(item.groupId));
    const grouped = groupBy(hasGroupSteps, 'groupId');
    const stepGroups = [];
    for (const key in flowGroup) {
      const group = flowGroup[key];
      stepGroups.push({
        ...group,
        steps: grouped[group.id],
      });
    }

    return [stepGroups, noGroupSteps];
  }, [flowGroup, steps]);

  return (
    <Root>
      <Title>执行清单</Title>
      <ConfigServerGroup groups={groups} />
      <ConfigServerHost steps={otherSteps} />
    </Root>
  );
}

export default connect((state) => ({
  steps: state.execFlow.steps,
  flowGroup: state.execFlow.flowGroup,
}))(Servers);

const Root = styled.div`
  flex: 1;
  padding: 16px 20px;
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`;
